import React, { useEffect, useState } from "react";
import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import MatchCard from "../../components/MatchCard";
import { useGetMyMatchesQuery } from "../../services/matchAPI";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../../uttils/UserPref";
import { colors } from "../../values/colors";
import { useNavigate } from "react-router-dom";
import { setWicketTypeData } from "../../redux/slices/outhow/wicketTypeSlice";
import { useGetOutHowQuery } from "../../services/outHowAPI";
import TournamentHome from "../Tournaments/TournamentHome";

const Home = (props) => {
  console.log("This is home page", window.history);

  const currentSelectedTab = useSelector(
    (state) => state.home.currentSelectedTab
  );

  console.log("CurrentSelectedTab", currentSelectedTab);

  const [status, setStatus] = useState("live");
  const [allTournaments, setAllTournaments] = useState(false);
  const [allIndividual, setAllIndividual] = useState(false);
  const [activeTab, setActiveTab] = useState("All");
  const navigate = useNavigate();

  const [liveTabSelected, setLiveTabSelected] = useState(true);
  const _selectTab = (live) => {
    live ? setLiveTabSelected(true) : setLiveTabSelected(false);
  };

  const { data: mymatches, refetch } = useGetMyMatchesQuery({
    status: status,
    allTournaments: allTournaments,
    allIndividual: allIndividual,
  });

  const displayAllIndividuals = () => {
    // Sab kuch ayega - In discussion ( Jisme ap khelto ho, and apne jo create kiya)
    if (activeTab !== "All") {
      setAllTournaments(false);
      setAllIndividual(false);
      setActiveTab("All");
    }
  };

  const displayAllTournaments = () => {
    if (activeTab !== "Tournament") {
      setAllTournaments(true);
      setAllIndividual(false);
      setActiveTab("Tournament");
    }
  };
  const myMatchesDisplayAll = () => {
    if (activeTab !== "My Matches") {
      setAllTournaments(false);
      setAllIndividual(true);
      setActiveTab("My Matches");
    }
  };

  useEffect(() => {
    const handleFocus = () => {
      refetch();
    };

    window.addEventListener("focus", handleFocus);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  const _onClick = (item) => {
    const data = {
      matchDetails: item,
    };
    navigate("/user/matchDetails", { state: data });
  };

  const MatchesSection = () => {
    return (
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
        }}
      >
        {/* <Header /> */}
        <Box sx={{ m: "20px" }}>
          <Stack
            mt={7}
            ml={4}
            direction={"row"}
            display={"flex"}
            sx={{ alignItems: "center" }}
          >
            <Typography variant="h6">Matches</Typography>
          </Stack>

          <Stack
            display="flex"
            m={2}
            my={4}
            direction={"row"}
            maxWidth={"25rem"}
            spacing={2}
          >
            <Button
              sx={{
                flex: 1,

                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={activeTab == "All" ? "selectedTab" : "unSelectedTab"}
              onClick={displayAllIndividuals}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: activeTab == "All" ? "#fff" : "#000",
                }}
              >
                All
              </Typography>
            </Button>
            <Button
              sx={{
                flex: 1,
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                activeTab === "Tournament" ? "selectedTab" : "unSelectedTab"
              }
              onClick={displayAllTournaments}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: activeTab === "Tournament" ? "#fff" : "#000",
                }}
              >
                Tournament
              </Typography>
            </Button>
            <Button
              sx={{
                flex: 1,

                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                activeTab === "My Matches" ? "selectedTab" : "unSelectedTab"
              }
              onClick={myMatchesDisplayAll}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  textWrap: "nowrap",
                  fontSize: "1rem",
                  color: activeTab === "My Matches" ? "#fff" : "#000",
                }}
              >
                My Matches
              </Typography>
            </Button>
          </Stack>

          <Stack m={2} my={4} direction={"row"} spacing={2} maxWidth={"25rem"}>
            <Button
              sx={{
                flex: 1,
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                status == "live" ? "selectedSubLiveTab" : "unSelectedSubLiveTab"
              }
              onClick={() => setStatus("live")}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: colors.textInputMandatory,
                }}
              >
                Live
              </Typography>
            </Button>
            <Button
              sx={{
                flex: 1,
                // paddingX: "5rem",
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                status == "scheduled"
                  ? "selectedSubLiveTab"
                  : "unSelectedSubLiveTab"
              }
              unSelectedSubLiveTab
              onClick={() => setStatus("scheduled")}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: colors.green,
                }}
              >
                Scheduled
              </Typography>
            </Button>
            <Button
              sx={{
                // paddingX: "5rem",
                flex: 1,
                paddingY: "0.6rem",
                textTransform: "initial",
              }}
              className={
                status == "completed"
                  ? "selectedSubLiveTab"
                  : "unSelectedSubLiveTab"
              }
              onClick={() => setStatus("completed")}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "1rem",
                  color: status == "completed" ? "#fff" : "#000",
                }}
              >
                Results
              </Typography>
            </Button>
          </Stack>

          <Grid2
            container
            size={12}
            sx={{
              height: "100%",
            }}
          >
            {mymatches?.data.map((ele) => (
              <Grid2 size={{ xs: 12, sm: 12, md: 4 }}>
                <MatchCard
                  enableShadow
                  item={ele}
                  onClick={_onClick}
                  enableOnClick={true}
                />
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    console.log("Home tab", currentSelectedTab);
  }, [currentSelectedTab]);

  return (
    (currentSelectedTab == "Matches" && <MatchesSection />) ||
    (currentSelectedTab == "Tournaments" && <TournamentHome />)
  );
};

export default Home;
